import { render } from "./ConfigLabel.vue?vue&type=template&id=6fd1c455&scoped=true&ts=true"
import script from "./ConfigLabel.vue?vue&type=script&lang=ts"
export * from "./ConfigLabel.vue?vue&type=script&lang=ts"

import "./ConfigLabel.vue?vue&type=style&index=0&id=6fd1c455&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd1c455"]])

export default __exports__